// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__43G2h","col":"Table_col__cMQgG","fulfillmentStatus":"Table_fulfillmentStatus__3ppRY","emailCol":"Table_emailCol__37d-R"};